import { render, staticRenderFns } from "./GameOverview.vue?vue&type=template&id=035cb561&"
import script from "./GameOverview.vue?vue&type=script&lang=ts&"
export * from "./GameOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports